import { Alert } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const Notification = () => {
  const { notification } = useSelector((state: any) => state.mmym);


  useEffect(() => {}, []);

  return (
    notification?.message && notification?.message?.length ? <Alert severity={notification?.severity}>
    {
        notification?.message && notification?.message?.map((message:any) => {
            return (<>{message} <br /></>)
        })
    }
    </Alert> : null
    
  );
};

export default Notification;
